import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  data() {
    return {
      showMenu: false,
    };
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapState('market', ['market', 'isMarketHistoryPinned', 'isWatchlistPinned', 'isSessionHistoryPinned']),
    itemWatchlistModifiers() {
      return {
        'sushi-market-links-toggle__menu-inner-item': true,
        'sushi-market-links-toggle__menu-inner-item--active': this.isWatchlistPinned,
      };
    },
    itemSessionHistoryModifiers() {
      return {
        'sushi-market-links-toggle__menu-inner-item': true,
        'sushi-market-links-toggle__menu-inner-item--active': this.isSessionHistoryPinned,
      };
    },
    itemMarketHistoryModifiers() {
      return {
        'sushi-market-links-toggle__menu-inner-item': true,
        'sushi-market-links-toggle__menu-inner-item--active': this.isMarketHistoryPinned,
      };
    },
  },
  methods: {
    ...mapActions('market', ['toggleWatchlistPin', 'toggleMarketHistoryPin', 'toggleSessionHistoryPin'])
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/page-market-detail-sushi/components/sushi-market-links-toggle/sushi-market-links-toggle.js